/**
 * One message carried from the field work list to the deployment page it opens: creating a
 * deployment navigates to it, and what the create queued ("The crew will be told.") belongs on the
 * page that opens, once. In memory only, for one deployment id, and read once.
 */
let pending: { id: string; text: string } | null = null;

export function setFlash(id: string, text: string | null): void {
  pending = text ? { id, text } : null;
}

export function takeFlash(id: string): string | null {
  if (pending?.id !== id) return null;
  const { text } = pending;
  pending = null;
  return text;
}

/**
 * What a save or a cancel queued, as a sentence: "will be told", never "has been told", and only
 * about somebody who was queued (23 Oct 2026). Null when nobody was.
 */
export function toldText(saved: { told: number; toldPm: boolean }): string | null {
  if (saved.told > 0 && saved.toldPm) return "The crew and the PM will be told.";
  if (saved.told > 0) return "The crew will be told.";
  if (saved.toldPm) return "The PM will be told.";
  return null;
}
